import EventTypeEvaluationPersonUpdated from '~/entities/evaluations/EventTypeEvaluations/PersonUpdated/PersonUpdated';
import EventTypeEvaluationsExternalAccountCreated from './EventTypeEvaluations/ExternalAccountCreated/ExternalAccountCreated';
import EventTypeEvaluationTransaction from './EventTypeEvaluations/Transaction/Transaction';

export const DATA_SERVICES = {
  LexisNexisWorldCompliance: 'LexisNexis WorldCompliance',
  Socure30: 'Socure 30',
};

export const DISPLAY_STATUSES = ['webhook_pending', 'waiting'];

export const EVENT_TYPE_EVALUATION_MAPPING = {
  person_updated: EventTypeEvaluationPersonUpdated,
  external_account_created: EventTypeEvaluationsExternalAccountCreated,
  transaction: EventTypeEvaluationTransaction,
};
